import { createSelector } from '@reduxjs/toolkit';

import { pick } from '~libs/dataUtils';

import {
  selectDerivedDateRange,
  selectParams,
  selectSearchParams,
  selectShowSystemUsers,
} from '~weekly-planner/selectors';

// simple date window queries
export type DateRangeReq = {
  week_start: string;
  week_end: string;
  limit?: number;
};

// assignable users can accept id or key
export type AssignableUsersReq = { id?: string | number; key?: string | number };

export type ExceptionsResponse = {
  rescheduled: any[];
  cancelled: any[];
};

const USERS_KEYS = ['limit', 'focus_appointment_id', 'focus_worker_id', 'filter_by', 'sort_by'] as const;

export const selectUsersApiArgs = createSelector(
  selectParams,
  selectSearchParams,
  selectDerivedDateRange,
  selectShowSystemUsers,
  (ui, search, range, showSystemUsers) => ({
    ...range,
    ...pick(ui, USERS_KEYS),
    ...search,
    ...(showSystemUsers ? { include: { show_system_users: true } } : {}),
    __refetchKey: ui.refetchKey,
  }),
);

export const selectClientsApiArgs = createSelector(
  selectParams,
  selectSearchParams,
  selectDerivedDateRange,
  (ui, search, range) => ({
    ...range,
    ...pick(ui, ['limit']),
    ...search,
    __refetchKey: ui.refetchKey,
  }),
);

// endpoints without simple date range
export const selectDateRangeArgs = createSelector(selectParams, selectDerivedDateRange, (ui, range) => ({
  ...range,
  ...pick(ui, ['limit']),
  __refetchKey: ui.refetchKey,
}));
